import React from 'react';
import FormRow, { FormRowProps } from './FormRow';

const MediumFormRow = ({ children, ...props }: FormRowProps) => {
  return (
    <FormRow colMd={12} colXl={6} {...props}>
      {children}
    </FormRow>
  );
};

export default MediumFormRow;
